import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { UserCacheService } from '../../../common/services/user-cache.service';
import { AppConstants } from '../../../common/constants/app-constants';
import { DataService } from '../../../common/services/data.service';
import { FwcModal } from '../../../../fwc-lib.js';

@Component({
    selector: 'sae-global-footer',
    templateUrl: './global-footer.component.html',
    styleUrls: ['./global-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalFooterComponent implements OnInit, OnDestroy {
  footer: {
    privacy: string,
    legal: string,
    contactInfo: any,
    tagline: string
  } = null;
  private dataSubscription: any;
  constructor(
    public userCacheService: UserCacheService,
    public dataService: DataService
  ){
    this.footer = userCacheService.getUserData(AppConstants.GLOBAL_FOOTER);
    this.dataSubscription = dataService.announcement.subscribe(announce => {
      if (announce != null && announce.topic === AppConstants.GLOBAL_FOOTER) {
        this.footer = announce.message;
      }
    });
    const fwcModal = new FwcModal();
    fwcModal.build();
  }
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  openModal(): void {
    const modal = document.getElementById('contactModal');
    modal.setAttribute('open', '');
  }

  closeModal(): void {
    const modal = document.getElementById('contactModal');
    modal.removeAttribute('open');
  }
}
